import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "../css/ModalLoading.module.css";
import Loading from "./Loading";

const ModalLoading = ({ message }) => {
  const { t } = useTranslation();
  const [dots, setDots] = useState("");
  const [showFirstMessage, setShowFirstMessage] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length === 3 ? "" : prev + "."));
    }, 350);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFirstMessage(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const firstMessageClasses = `${styles.firstMessage} ${
    showFirstMessage ? styles.messageVisible : ""
  }`;

  return (
    <div className={styles.moduleLoadingOverlay}>
      <div className={styles.moduleLoading}>
        <h3 className={firstMessageClasses}>
          {t("modalLoading.stillWaiting")}
        </h3>

        <Loading />

        <h3 style={{ color: "white", whiteSpace: "nowrap" }}>
          {message ? message : t("modalLoading.loadingText")}
          <span style={{ display: "inline-block", width: "1ch" }}>{dots}</span>
        </h3>
      </div>
    </div>
  );
};

export default ModalLoading;